module.exports = __webpack_public_path__ + "8ddc97b52ec2cc2297de9bfcb6c94684.pdf";